const _ = require('lib/underscore')
const BaseElement = require('./element.base')

const RadioElement = BaseElement.extend({

    validateConstructor(attrs) {
        if (_.isUndefined(attrs.value)) {
            throw new Error('Radio Element requires a value.')
        }
        return attrs
    },

})

module.exports = RadioElement
